import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Label, Alert, Button, Form, Table } from "reactstrap";
import Page from "components/Page";
import { Textbox, Select } from "react-inputs-validation";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import ValoresCotizacionHogar from "./ValoresCotizacionHogar";
import { FetchCalculoPrimaHogar, FetchListarCarritoHogar, setProductoActualCotizadoHogar, FetchGenerarEnviarPdfHogar, FetchTotalesCabeceraCotizadores, FetchDataCoberturasHogarAdvance } from "../../redux/actions/ACarritoProductos";
import { recuperarDatosFacturacionFetch } from "../../redux/actions/aCotizacion";
import { SelectButton } from "primereact/selectbutton";
import Planes from '../Generales/Planes';



const arrayRiesgos = [
  { id: 2, name: "Primer Riesgo Relativo" },
  { id: 1, name: "Primer Riesgo Absoluto" }
];

class CotizacionValoresPaso4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      formEditado: false,
      arrayDeducibles: this.props.catalogosHogar.setRelatividadesHogar.deductibles ? this.props.catalogosHogar.setRelatividadesHogar.deductibles : [],
      deducibleSelected: this.props.catalogosHogar.setRelatividadesHogar.valorDefectoDeducible ? this.props.catalogosHogar.setRelatividadesHogar.valorDefectoDeducible : "",
      riesgoSelected: 2,
      esAdvance: this.props.carrito.carDescripcionSeguro == 'HOGAR ADVANCE' ? true : false,
      //Seccion de incendios
      seccionIncendios: undefined,
      arrayValoresSeccionIncendios: undefined,
      arrayErroresIncendio: undefined,
      //Seccion de Robo
      seccionRobo: undefined,
      arrayValoresSeccionRobo: undefined,
      arrayErroresRobo: undefined,
      cargarTotalesRecuperado: false,
      habilitarBotonContinuar: this.props.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima === "" ? false : true,
      //Seccion Amparos Basico de Daños
      seccionAmparosBasicosDanios: undefined,
      arrayValoresAmparosBasicosDanios: undefined,
      mostrarAmparosBasicosDanios: false,
      // Seccion de Amparos Derivados de Siniestros        
      seccionAmparosBasicosDerivadoSiniestros: undefined,
      arrayValoresAmparosBasicosDerivadoSiniestros: undefined,
      mostrarAmparosBasicosDerivadoSiniestros: false,
      // Seccion de Amparos Opcionales       
      seccionAmparosOpcionales: undefined,
      arrayValoresAmparosOpcionales: undefined,
      arrayErroresAmparosOpcionales: undefined,
      verNumeroPersonasAP: undefined,
      NumeroPersonasvalidador: undefined,
      codigoProductoEspecial: null,
      planContenidosSeleccionado: null,
      planEstructuraSeleccionado: null,
      valoresCobertura: []

    };
  }

  onRegresar = async () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const codEdicion = queryParams.get('codEdicion');
    const cod = queryParams.get('cod');
    if (codEdicion === undefined || codEdicion === '' || codEdicion === null) {
      this.props.history.push({
        pathname: "/cotizacion-hogar-paso3",
        search: `?back=true`
      });
    }
    else {
      this.props.history.push({
        pathname: "/cotizacion-hogar-paso3",
        search: `codEdicion=${codEdicion}`, //agregar parametros de la url,
      });
    }
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }

  onValidateform = async () => {
    let { formEditado, arrayValoresSeccionIncendios, seccionIncendios, arrayErroresIncendio, arrayErroresRobo, arrayValoresSeccionRobo, seccionRobo, seccionAmparosBasicosDanios, deducibleSelected, arrayDeducibles, riesgoSelected, seccionAmparosBasicosDerivadoSiniestros, mostrarAmparosBasicosDerivadoSiniestros, mostrarAmparosBasicosDanios, seccionAmparosOpcionales, arrayValoresAmparosOpcionales, verNumeroPersonasAP, NumeroPersonasvalidador } = this.state;


    if (formEditado === true) {

      if (this.state.esAdvance) {

        const datosEnviar = {
          empresa: "AIGMETROPOLITANA",
          idCarrito: this.props.carrito.mongoCarrito,
          planEstructura: this.state.planEstructuraSeleccionado,
          planContenidos: this.state.planContenidosSeleccionado,
          numItem: this.props.datosCarritoHogar.setCarritoHogar.carProductos 
            ? this.props.datosCarritoHogar.setCarritoHogar.carProductos.length
            : 0,
        }



        await this.props.caluloPrima(datosEnviar);

        let datosCarritoHogar =
        {
          "empresa": "AIGMETROPOLITANA",
          "idCarrito": this.props.carrito.mongoCarrito
        }
        await this.props.listarCarritoHogar(datosCarritoHogar);
        // actualizar los datos del cotizadores                          


        let datosJSON = {
          empresa: "AIGMETROPOLITANA",
          plataforma: "WEB",
          idCarrito: this.props.carrito.mongoCarrito
        }

        await this.props.datosFacturacion(datosJSON);
        if (this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "") {
          let param = {
            pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
            totalItems: this.props.dataFacturacion.numItemsCarrito ? this.props.dataFacturacion.numItemsCarrito : "0",
            totalPrima: (this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal) ? this.props.dataFacturacion.carValoresTotales.primaTotal : "0.00",
            ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
          }
          await this.props.actualizarTotalesCabecera(param);
        }







        this.setState({
          formEditado: false
        })

      } else {
        let HasError = false;
        this.toggleValidating(true);
        //validar que los valores del array de cada seccion se encuentre lleno
        arrayValoresSeccionIncendios.forEach((element, i) => {
          if (element.cobValorIngresado < 0 || element.cobValorIngresado === "" || element.cobValorIngresado === null) {
            HasError = true;
          }
        });
        arrayValoresSeccionRobo.forEach((element, i) => {
          if (element.cobValorIngresado < 0 || element.cobValorIngresado === "" || element.cobValorIngresado === null) {
            HasError = true;
          }
        });
        if (deducibleSelected === "") {
          HasError = true;
        }
        if (verNumeroPersonasAP && verNumeroPersonasAP === true) {
          if (!NumeroPersonasvalidador || NumeroPersonasvalidador === undefined || NumeroPersonasvalidador === "" || NumeroPersonasvalidador <= 0) {
            HasError = true;
          }
        }
        if (!HasError) {
          //Crear objeto para los deducibles      
          let ObjDeducible = arrayDeducibles.filter((item) =>
            item.id === deducibleSelected.toString()
          )
          ObjDeducible = ObjDeducible[0];
          //Preparar los campos ingresados Seccion Incendios     
          seccionIncendios.secCoberturas = arrayValoresSeccionIncendios;
          seccionRobo.secCoberturas = arrayValoresSeccionRobo;
          seccionAmparosOpcionales.secCoberturas = arrayValoresAmparosOpcionales;

          let arraySecciones = [];
          arraySecciones.push(seccionIncendios);
          arraySecciones.push(seccionRobo);
          arraySecciones.push(seccionAmparosOpcionales);

          //Validar que no sea una edicion de ubicacion
          const queryParams = new URLSearchParams(this.props.location.search);
          const codEdicion = queryParams.get('codEdicion');
          let cod = this.props.carrito.carCodigoProductoActual
          if (codEdicion !== undefined && codEdicion !== "" && codEdicion !== null) {
            cod = codEdicion
          }
          //armar el objeto para enviar información al servicio      
          const datosEnviar = {
            empresa: "AIGMETROPOLITANA",
            idCarrito: this.props.carrito.mongoCarrito,
            planEstructura: null,
            planContenidos: null,
            secciones: arraySecciones,
            codigo: cod,
            amparosDaniosPerdidas: seccionAmparosBasicosDanios,
            amparosDerivadosSiniestros: seccionAmparosBasicosDerivadoSiniestros,
            deductibles: ObjDeducible,
            tipoValorRobo: riesgoSelected,
          }
          console.log(JSON.stringify(datosEnviar))
          await this.props.caluloPrima(datosEnviar);
          //Verificar si la respuesta es correcta o incorrecta
          if (this.props.datosCarritoHogar.setCalculoPrimaHogarErrores !== undefined && this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.transaccion == false) {
            if (this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.seccionesResultado) {
              // Obtener el array de errores de carrito Incendio
              let ObtenerErroresIncendio = this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.seccionesResultado.filter((item) =>
                item.secCodigo === "incendio"
              )
              ObtenerErroresIncendio = ObtenerErroresIncendio[0];
              // Obtener el array de errores de carrito Robo
              let ObtenerErroresRobo = this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.seccionesResultado.filter((item) =>
                item.secCodigo === "robo"
              )
              ObtenerErroresRobo = ObtenerErroresRobo[0];
              // Obtener el array de errores Amparos Opcionales
              let ObtenerErroresAmparosOpcionales = this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.seccionesResultado.filter((item) =>
                item.secCodigo === "amparosOpcionales"
              )
              ObtenerErroresAmparosOpcionales = ObtenerErroresAmparosOpcionales[0];

              this.setState({
                arrayErroresIncendio: ObtenerErroresIncendio.segErrores,
                arrayErroresRobo: ObtenerErroresRobo.segErrores,
                arrayErroresAmparosOpcionales: ObtenerErroresAmparosOpcionales ? ObtenerErroresAmparosOpcionales.segErrores : undefined,
                cargarTotalesRecuperado: false
              })
              //actualizar los totales
              let param = { pathIcono: "", totalItems: "0", totalPrima: "0.00", ramoCotizador: "" }
              await this.props.actualizarTotalesCabecera(param);
            }
          }

          if (this.props.datosCarritoHogar.setCalculoPrimaHogar !== undefined && this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado !== undefined) {
            if (this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado) {
              // buscar el array de respuesta por codigo incendio
              let PrimasCalculadasIcendio = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "incendio"
              )
              PrimasCalculadasIcendio = PrimasCalculadasIcendio[0];
              // buscar el array de respuesta por codigo robo
              let PrimasCalculadasRobo = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "robo"
              )
              PrimasCalculadasRobo = PrimasCalculadasRobo[0];
              // buscar el array de respuesta por codigo los Amparos de Daños
              let CalculosAmparosDaniosPerdidas = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "amparosDaniosPerdidas"
              )
              CalculosAmparosDaniosPerdidas = CalculosAmparosDaniosPerdidas[0];
              if (CalculosAmparosDaniosPerdidas && CalculosAmparosDaniosPerdidas.secCoberturasResultado) {
                CalculosAmparosDaniosPerdidas.secCoberturas = CalculosAmparosDaniosPerdidas.secCoberturasResultado;
                //Visualizar seccion
                this.setState({ mostrarAmparosBasicosDanios: CalculosAmparosDaniosPerdidas.secMostrarSeccion ? CalculosAmparosDaniosPerdidas.secMostrarSeccion : false })
              }
              // buscar el array de respuesta por codigo los Amparos de gastos adicionales derivados desiniestro
              let CalculosAmparosDerivadoSiniestros = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "amparosDerivadoSiniestros"
              )
              CalculosAmparosDerivadoSiniestros = CalculosAmparosDerivadoSiniestros[0];
              if (CalculosAmparosDaniosPerdidas && CalculosAmparosDaniosPerdidas.secCoberturasResultado) {
                CalculosAmparosDerivadoSiniestros.secCoberturas = CalculosAmparosDerivadoSiniestros.secCoberturasResultado;
                //Visualizar seccion
                this.setState({ mostrarAmparosBasicosDerivadoSiniestros: CalculosAmparosDaniosPerdidas.secMostrarSeccion ? CalculosAmparosDaniosPerdidas.secMostrarSeccion : false })
              }

              // buscar el array de respuesta por codigo amparosOpcionales
              let PrimasCalculadasAmparosOpcionales = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "amparosOpcionales"
              )
              PrimasCalculadasAmparosOpcionales = PrimasCalculadasAmparosOpcionales[0];

              this.setState({
                arrayValoresSeccionIncendios: PrimasCalculadasIcendio.secCoberturasResultado,
                arrayErroresIncendio: undefined,
                arrayValoresSeccionRobo: PrimasCalculadasRobo.secCoberturasResultado,
                arrayErroresRobo: undefined,
                seccionAmparosBasicosDanios: CalculosAmparosDaniosPerdidas,
                arrayValoresAmparosBasicosDanios: CalculosAmparosDaniosPerdidas ? CalculosAmparosDaniosPerdidas.secCoberturas : undefined,
                seccionAmparosBasicosDerivadoSiniestros: CalculosAmparosDerivadoSiniestros,
                arrayValoresAmparosBasicosDerivadoSiniestros: CalculosAmparosDerivadoSiniestros ? CalculosAmparosDerivadoSiniestros.secCoberturas : undefined,
                arrayValoresAmparosOpcionales: PrimasCalculadasAmparosOpcionales.secCoberturasResultado,
                arrayErroresAmparosOpcionales: undefined,
                validate: false,
                cargarTotalesRecuperado: false
              })
              //Listar todo el carrito cuando se efectuaron correctamente los cálculos
              let datosCarritoHogar =
              {
                "empresa": "AIGMETROPOLITANA",
                "idCarrito": this.props.carrito.mongoCarrito
              }
              await this.props.listarCarritoHogar(datosCarritoHogar);
              // actualizar los datos del cotizadores                          
              let datosJSON = {
                empresa: "AIGMETROPOLITANA",
                plataforma: "WEB",
                idCarrito: this.props.carrito.mongoCarrito
              }
              await this.props.datosFacturacion(datosJSON);
              if (this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "") {
                let param = {
                  pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
                  totalItems: this.props.dataFacturacion.numItemsCarrito ? this.props.dataFacturacion.numItemsCarrito : "0",
                  totalPrima: (this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal) ? this.props.dataFacturacion.carValoresTotales.primaTotal : "0.00",
                  ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
                }
                await this.props.actualizarTotalesCabecera(param);
              }

            }
          }
          this.setState({ formEditado: false })
        }

      }

    }
    else {
      //armar el objeto para enviar información al servicio      
      const datosEnviar = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        idCarrito: this.props.carrito.mongoCarrito,
        accion: "generar"

      }
      //console.log("DatosGenerarPdf",JSON.stringify(datosEnviar))   
      await this.props.guardarGenerarPdfCotizacion(datosEnviar);



      if (this.props.datosCarritoHogar.setGenerarPdfCotizacionHogar !== undefined && this.props.datosCarritoHogar.setGenerarPdfCotizacionHogar.transaccion === true) {
        this.props.history.push({
          pathname: "/cotizacion-hogar-paso5",
          search: `?idCarrito=${this.props.carrito.mongoCarrito}`

        });
      }

    }

  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima !== prevProps.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima) {
      // Validar si la prima es valor al valor parametrizable y permitir continuar o bloquear el flujo
      if (this.props.datosCarritoHogar && this.props.datosCarritoHogar.setCarritoHogar && this.props.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima === "") {
        this.setState({ habilitarBotonContinuar: false });
      }
      else {
        this.setState({ habilitarBotonContinuar: true });
      }
      //Fin Validar si la prima es valor al valor parametrizable y permitir continuar o bloquear el flujo
    }
    if (this.props.datosCarritoHogar.calculoPrimaHogarError !== prevProps.datosCarritoHogar.calculoPrimaHogarError) {
      this.setState({ habilitarBotonContinuar: this.props.datosCarritoHogar.calculoPrimaHogarError });
    }
  }

  async componentDidMount() {

    await this.props.cargarCoberturasHogarAdvance();

    this.obtenerValores()

    console.log('productosHogar: ', this.props.datosCarritoHogar)
    window.scrollTo(0, 0)
    //Validar que la cotizacion sea nueva o es recuperacion
    const queryParams = new URLSearchParams(this.props.location.search);
    const recuperar = queryParams.get('recuperar');
    let codigoProductoEspecial = queryParams.get("producto");
    if (codigoProductoEspecial != null || this.props.datosCarritoHogar.setCarritoHogar.carDescripcionSeguro == 'HOGAR ADVANCE') {
      this.setState({ codigoProductoEspecial: codigoProductoEspecial || this.props.datosCarritoHogar.setCarritoHogar.carDescripcionSeguro });
    }
    //Validar que se este recuperando la cotizacion    
    if (recuperar && recuperar !== null && recuperar !== "" && recuperar !== undefined && (recuperar === true || recuperar === "true")) {
      this.precargarSeccionesCotizacionRecuperada();
      this.precargarPlanes()
    }
    else {
      this.precargarSeccionesCotizacionNueva();
    }

  }


  obtenerValores() {

    var auxPrincipal = [];

    this.props.datosCarritoHogar.setPlanesHogarAdvance.planesContenido[0].valoresCobertura.forEach(cobertura => {
      var auxSecundario = []

      this.props.datosCarritoHogar.setPlanesHogarAdvance.planesContenido.forEach(plan => {

        plan.valoresCobertura.forEach(valor => {

          if (cobertura.titulo == valor.titulo) {
            auxSecundario.push(valor)

          }

        });

      });
      auxPrincipal.push(auxSecundario)

    })
    this.setState({
      valoresCobertura: auxPrincipal
    })

    console.log('obtenerValores', auxPrincipal)





  }



  async precargarPlanes() {

    if (this.props.datosCarritoHogar.setCarritoHogar.carProductos[0] && this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planContenidos && this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planContenidos.primaCobertura) {
      this.setState({
        planContenidosSeleccionado: this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planContenidos.codigoProducto,
        formEditado: true,
      })
    }

    if (this.props.datosCarritoHogar.setCarritoHogar.carProductos[0] && this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planEstructura && this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planEstructura.primaCobertura) {
      this.setState({
        planEstructuraSeleccionado: this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planEstructura.codigoProducto,
        formEditado: true
      })
    }
  }


  async precargarSeccionesCotizacionRecuperada() {
    //Obtener el ultimo producto que se estuvo cotizando
    let codigoProductoActual = this.props.datosCarritoHogar.setCarritoHogar.carCodigoProductoActual;
    //Verificar si es una edicion
    const queryParams = new URLSearchParams(this.props.location.search);
    const codigoProdActual = queryParams.get('cod');
    const codEdicion = queryParams.get('codEdicion');
    if (codigoProdActual && codigoProdActual !== undefined && codigoProdActual !== '') {
      codigoProductoActual = codigoProdActual;
    }
    else if (codEdicion && codEdicion !== undefined && codEdicion !== '') {
      codigoProductoActual = codEdicion;
    }

    //validar si existen actualizaciones de datos para el scoring
    if (this.props.datosCarritoHogar.setCarritoHogar && this.props.datosCarritoHogar.setCarritoHogar.leadUltimosPasosPorItem && this.props.datosCarritoHogar.setCarritoHogar.leadUltimosPasosPorItem !== undefined && this.props.datosCarritoHogar.setCarritoHogar.leadUltimosPasosPorItem !== "") {
      let ObtenerItemPasos = this.props.datosCarritoHogar.setCarritoHogar.leadUltimosPasosPorItem.filter((item) =>
        item.codigo === codigoProductoActual
      )
      ObtenerItemPasos = ObtenerItemPasos[0];
      if (ObtenerItemPasos.banderaEdicion && ObtenerItemPasos.banderaEdicion === 'true') {
        //Estilo al boton actualizar
        this.setState({ formEditado: true });
      }
    }

    // Buscar el producto en el carrito
    let ObtenerProductoActual = this.props.datosCarritoHogar.setCarritoHogar.carProductos.filter((item) =>
      item.codigo === codigoProductoActual
    )
    ObtenerProductoActual = ObtenerProductoActual[0];
    //Setear Producto actual
    await this.props.setProductoActual(ObtenerProductoActual);
    if (ObtenerProductoActual.coberturas) {
      //Obtener Secciones Coberturas Incendio
      let ObtenerSeccionIcendio = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "incendio"
      )
      ObtenerSeccionIcendio = ObtenerSeccionIcendio[0];
      //Obtener Secciones Coberturas Robo
      let ObtenerSeccionRobo = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "robo"
      )
      ObtenerSeccionRobo = ObtenerSeccionRobo[0];
      //Precargar las secciones y coberturas del servicio para las secciones      
      let ObtenerSeccionIcendioCatalogo = this.props.seccionesCoberturasHogar.filter((item) =>
        item.secCodigo === "incendio"
      )
      ObtenerSeccionIcendioCatalogo = ObtenerSeccionIcendioCatalogo[0];

      let ObtenerSeccionRoboCatalogo = this.props.seccionesCoberturasHogar.filter((item) =>
        item.secCodigo === "robo"
      )
      ObtenerSeccionRoboCatalogo = ObtenerSeccionRoboCatalogo[0];
      //Validar que en la recuperacion el array de valores de las secciones tenga valores
      let arrayValoresIncendio = undefined;
      if (ObtenerSeccionIcendio && ObtenerSeccionIcendio.secCoberturasResultado === undefined || ObtenerSeccionIcendio.secCoberturasResultado === null) {
        //Obtener Secciones Coberturas Incendio
        let ObjIcendio = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "incendio"
        )
        ObjIcendio = ObjIcendio[0];
        //Construir array de secciones con valores defecto Incendio
        ObjIcendio.secCoberturas.forEach((element, i) => {
          ObjIcendio.secCoberturas[i] = { ...ObjIcendio.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
        });
        arrayValoresIncendio = ObjIcendio.secCoberturas;
      }
      else {
        arrayValoresIncendio = ObtenerSeccionIcendio.secCoberturasResultado;
      }
      let arrayValoresRobo = undefined;
      if (!ObtenerSeccionRobo) {
        //Obtener Secciones Coberturas Incendio
        let Obj = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "incendio"
        )
        Obj = Obj[0];
        //Construir array de secciones con valores defecto Incendio
        Obj.secCoberturas.forEach((element, i) => {
          Obj.secCoberturas[i] = { ...Obj.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
        });
        arrayValoresRobo = Obj.secCoberturas;
      }
      else {
        arrayValoresRobo = ObtenerSeccionRobo.secCoberturasResultado;
      }
      //Obtener las secciones de Amparos Básico de Daños
      let ObtenerSeccionAmparosBasicosDaniosAux = undefined;
      let ObtenerSeccionAmparoBasicoDanios = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "amparosDaniosPerdidas"
      )
      ObtenerSeccionAmparoBasicoDanios = ObtenerSeccionAmparoBasicoDanios[0];
      if (ObtenerSeccionAmparoBasicoDanios) {
        ObtenerSeccionAmparosBasicosDaniosAux = ObtenerSeccionAmparoBasicoDanios.secCoberturasResultado;
        if (!ObtenerSeccionAmparoBasicoDanios.secCoberturas) {
          ObtenerSeccionAmparoBasicoDanios.secCoberturas = ObtenerSeccionAmparoBasicoDanios.secCoberturasResultado;
        }
      }
      else {
        //Obtener Seccion Amparos Basicos de Daños
        ObtenerSeccionAmparosBasicosDaniosAux = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "amparosDaniosPerdidas"
        )
        ObtenerSeccionAmparosBasicosDaniosAux = ObtenerSeccionAmparosBasicosDaniosAux[0];
      }
      //Obtener las secciones de Amparos de Gasto Derivados Siniestro
      let ObtenerSeccionAmparosDerivadoSiniestroAux = undefined;
      let ObtenerSeccionAmparoDerivadoSiniestros = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "amparosDerivadoSiniestros"
      )
      ObtenerSeccionAmparoDerivadoSiniestros = ObtenerSeccionAmparoDerivadoSiniestros[0];
      if (ObtenerSeccionAmparoDerivadoSiniestros) {
        ObtenerSeccionAmparosDerivadoSiniestroAux = ObtenerSeccionAmparoDerivadoSiniestros.secCoberturasResultado;
        if (!ObtenerSeccionAmparoDerivadoSiniestros.secCoberturas) {
          ObtenerSeccionAmparoDerivadoSiniestros.secCoberturas = ObtenerSeccionAmparoDerivadoSiniestros.secCoberturasResultado;
        }
      }
      else {
        //Obtener Seccion Amparos Basicos de Daños
        ObtenerSeccionAmparosDerivadoSiniestroAux = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "amparosDerivadoSiniestros"
        )
        ObtenerSeccionAmparosDerivadoSiniestroAux = ObtenerSeccionAmparosDerivadoSiniestroAux[0];
      }


      //Obtener Secciones Coberturas de Amparos Opcionales
      let ObtenerSeccionAmparosOpcionales = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "amparosOpcionales"
      )
      ObtenerSeccionAmparosOpcionales = ObtenerSeccionAmparosOpcionales[0];

      //Precargar las secciones y coberturas de Amparos Opcionales del Catalogo
      let ObtenerSeccionAmparosOpcionalesCatalogo = this.props.seccionesCoberturasHogar.filter((item) =>
        item.secCodigo === "amparosOpcionales"
      )
      ObtenerSeccionAmparosOpcionalesCatalogo = ObtenerSeccionAmparosOpcionalesCatalogo[0];

      //Validar que en la recuperacion el array de valores de las seccion Amparos Opcionales tenga valores
      let arrayValoresAmparosOpcionales = undefined;
      if (ObtenerSeccionAmparosOpcionales && ObtenerSeccionAmparosOpcionales.secCoberturasResultado === undefined || ObtenerSeccionAmparosOpcionales.secCoberturasResultado === null) {
        //Obtener Secciones Coberturas Amparos Opcionares
        let ObjAmpOpcionales = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "amparosOpcionales"
        )
        ObjAmpOpcionales = ObjAmpOpcionales[0];
        //Construir array de secciones con valores Amparos Opcionares
        ObjAmpOpcionales.secCoberturas.forEach((element, i) => {
          if (element.cobCodigo === "personalDomestico") {
            ObjAmpOpcionales.secCoberturas[i] = { ...ObjAmpOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00", cobNumeroPersonas: 0 }
          }
          else {
            ObjAmpOpcionales.secCoberturas[i] = { ...ObjAmpOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
          }
        });
        arrayValoresAmparosOpcionales = ObjAmpOpcionales.secCoberturas;
      }
      else {
        arrayValoresAmparosOpcionales = ObtenerSeccionAmparosOpcionales.secCoberturasResultado;
      }
      //Validar si es que ha sido ingresado un valor en AP de personas para mostrar la seccion
      arrayValoresAmparosOpcionales.forEach((element, i) => {
        if (element.cobCodigo === "personalDomestico" && parseFloat(element.cobValorIngresado) > 0 && element.cobNumeroPersonas && parseInt(element.cobNumeroPersonas) > 0) {
          this.setState({
            verNumeroPersonasAP: true,
            NumeroPersonasvalidador: element.cobValorIngresado
          })
        }
      });

      //Construir array de secciones con valores defecto Robo
      this.setState({
        arrayValoresSeccionIncendios: arrayValoresIncendio,
        arrayErroresIncendio: undefined,
        arrayValoresSeccionRobo: arrayValoresRobo,
        arrayErroresRobo: undefined,
        seccionIncendios: ObtenerSeccionIcendioCatalogo,
        seccionRobo: ObtenerSeccionRoboCatalogo,
        cargarTotalesRecuperado: true,
        seccionAmparosBasicosDanios: ObtenerSeccionAmparoBasicoDanios,
        arrayValoresAmparosBasicosDanios: ObtenerSeccionAmparosBasicosDaniosAux,
        deducibleSelected: parseInt(ObtenerProductoActual.deducibleSeleccionadoUsuario),
        riesgoSelected: parseInt(ObtenerProductoActual.tipoValorRobo),
        seccionAmparosBasicosDerivadoSiniestros: ObtenerSeccionAmparoDerivadoSiniestros,
        arrayValoresAmparosBasicosDerivadoSiniestros: ObtenerSeccionAmparosDerivadoSiniestroAux,
        mostrarAmparosBasicosDanios: ObtenerSeccionAmparoBasicoDanios.secMostrarSeccion ? ObtenerSeccionAmparoBasicoDanios.secMostrarSeccion : false,
        mostrarAmparosBasicosDerivadoSiniestros: ObtenerSeccionAmparoDerivadoSiniestros.secMostrarSeccion ? ObtenerSeccionAmparoDerivadoSiniestros.secMostrarSeccion : false,
        arrayValoresAmparosOpcionales: arrayValoresAmparosOpcionales,
        arrayErroresAmparosOpcionales: undefined,
        seccionAmparosOpcionales: ObtenerSeccionAmparosOpcionalesCatalogo,
      })
    }
    else {
      this.precargarSeccionesCotizacionNueva()
    }
  }





  async precargarSeccionesCotizacionNueva() {
    //Obtener Secciones Coberturas Incendio
    let ObtenerSeccionIcendio = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "incendio"
    )
    ObtenerSeccionIcendio = ObtenerSeccionIcendio[0];
    //Construir array de secciones con valores defecto Incendio
    ObtenerSeccionIcendio.secCoberturas.forEach((element, i) => {
      ObtenerSeccionIcendio.secCoberturas[i] = { ...ObtenerSeccionIcendio.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
    });

    //Obtener Secciones Coberturas Robo
    let ObtenerSeccionRobo = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "robo"
    )
    ObtenerSeccionRobo = ObtenerSeccionRobo[0];
    //Construir array de secciones con valores defecto Robo
    ObtenerSeccionRobo.secCoberturas.forEach((element, i) => {
      ObtenerSeccionRobo.secCoberturas[i] = { ...ObtenerSeccionRobo.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
    });

    //Obtener Seccion Amparos Basicos de Daños
    let ObtenerSeccionAmparosBasicosDanios = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "amparosDaniosPerdidas"
    )
    ObtenerSeccionAmparosBasicosDanios = ObtenerSeccionAmparosBasicosDanios[0];

    //Obtener Seccion Amparos Derivados de Siniestros
    let ObtenerSeccionAmparosDerivadosSiniestros = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "amparosDerivadoSiniestros"
    )
    ObtenerSeccionAmparosDerivadosSiniestros = ObtenerSeccionAmparosDerivadosSiniestros[0];

    //Obtener Seccion Amparos Opcionales
    let ObtenerSeccionAmparosOpcionales = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "amparosOpcionales"
    )
    ObtenerSeccionAmparosOpcionales = ObtenerSeccionAmparosOpcionales[0];
    //Construir array de secciones con valores defecto amparos Opcionales
    ObtenerSeccionAmparosOpcionales.secCoberturas.forEach((element, i) => {
      if (element.cobCodigo === "personalDomestico") {
        ObtenerSeccionAmparosOpcionales.secCoberturas[i] = { ...ObtenerSeccionAmparosOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00", cobNumeroPersonas: 0 }
      }
      else {
        ObtenerSeccionAmparosOpcionales.secCoberturas[i] = { ...ObtenerSeccionAmparosOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
      }
    });
    this.setState({
      seccionIncendios: ObtenerSeccionIcendio,
      arrayValoresSeccionIncendios: ObtenerSeccionIcendio.secCoberturas,
      seccionRobo: ObtenerSeccionRobo,
      arrayValoresSeccionRobo: ObtenerSeccionRobo.secCoberturas,
      seccionAmparosBasicosDanios: ObtenerSeccionAmparosBasicosDanios,
      arrayValoresAmparosBasicosDanios: ObtenerSeccionAmparosBasicosDanios.secCoberturas,
      seccionAmparosBasicosDerivadoSiniestros: ObtenerSeccionAmparosDerivadosSiniestros,
      arrayValoresAmparosBasicosDerivadoSiniestros: ObtenerSeccionAmparosDerivadosSiniestros.secCoberturas,
      seccionAmparosOpcionales: ObtenerSeccionAmparosOpcionales,
      arrayValoresAmparosOpcionales: ObtenerSeccionAmparosOpcionales.secCoberturas,
    });

    let datosJSON = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      idCarrito: this.props.carrito.mongoCarrito
    }
    await this.props.datosFacturacion(datosJSON);
    if (this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "") {
      let param = undefined;
      if (parseInt(this.props.dataFacturacion.numItemsCarrito) > 1) {
        param = {
          pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
          totalItems: this.props.dataFacturacion.numItemsCarrito ? this.props.dataFacturacion.numItemsCarrito : "0",
          totalPrima: (this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal) ? this.props.dataFacturacion.carValoresTotales.primaTotal : "0.00",
          ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
        }
      }
      else {
        param = {
          pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
          totalItems: "1",
          totalPrima: "0.00",
          ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
        }
      }
      await this.props.actualizarTotalesCabecera(param);
    }

  }

  render() {
    let { seccionIncendios, arrayValoresSeccionIncendios, validate, formEditado, arrayErroresIncendio, seccionRobo, arrayValoresSeccionRobo, arrayErroresRobo, cargarTotalesRecuperado, habilitarBotonContinuar, arrayValoresAmparosBasicosDanios, seccionAmparosBasicosDanios, deducibleSelected, arrayDeducibles, riesgoSelected, seccionAmparosBasicosDerivadoSiniestros, arrayValoresAmparosBasicosDerivadoSiniestros, mostrarAmparosBasicosDanios, mostrarAmparosBasicosDerivadoSiniestros, seccionAmparosOpcionales, arrayValoresAmparosOpcionales, arrayErroresAmparosOpcionales, verNumeroPersonasAP, NumeroPersonasvalidador } = this.state;
    return (
      <LoadingScreen
        loading={this.props.datosCarritoHogar.calculoPrimaHogarloading || this.props.datosCarritoHogar.generarPdfCotizacionHogarloading || this.props.datosCarritoHogar.planesHogarAdvanceLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >
        <Page title={!(this.state.esAdvance) ? "Cotización de Hogar Protección Total" : "Cotización de Hogar Advance"} breadcrumbs={[{ name: !(this.state.esAdvance) ? "Cotización de Hogar Protección Total" : "Cotización de Hogar Advance", active: true }]}>
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step current"> {`1. Cotización`} </div>
                    <div className="step"> {`2. Resumen`} </div>
                    <div className="step"> {`3. Confirmación`} </div>
                    <div class="step"> {` 4. Forma de Pago `} </div>
                    <div class="step"> {` 5. Formulario de Vinculación `} </div>
                    <div class="step"> {` 6. Emisión `} </div>
                  </div>
                </div>
              </div>
              <Button className={"button-white"} onClick={this.onRegresar}>
                <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                REGRESAR
              </Button>
            </Col>
          </Row>
          <Row>
            <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box" >
              {seccionIncendios !== undefined && seccionIncendios.secCoberturas !== undefined &&
                <div>
                  {/** --------------Deducible Terremoto ---------------------------------------------------------*/}
                  {this.state.codigoProductoEspecial == null &&

                    <Card className="flex-row">
                      <CardBody>
                        <h4 style={{ fontWeight: "bold" }}>Información del Riesgo</h4>
                        <p />
                        <Row >
                          <Col lg={4} md={12} sm={12} xs={12}>Deducible Terremoto Aplicado</Col>
                          <Col lg={4} md={12} sm={12} xs={12}>
                            <Select
                              id={"selectDeducibles"} // Optional.[String].Default: "". Input ID.
                              name={"selectDeducibles"} // Optional.[String].Default: "". Input name.
                              value={deducibleSelected} // Optional.[String].Default: "".
                              optionList={arrayDeducibles.sort((a, b) => a.value - b.value)} // Required.[Array of Object(s)].Default: [].
                              onChange={(deducibleSelected, e) => {
                                this.setState({ deducibleSelected, formEditado: true, habilitarBotonContinuar: false });
                              }} // Optional.[Func].Default: () => {}. Will return the value.
                              validate={validate}
                              validationCallback={res =>
                                this.setState({ validate: false })
                              }
                              classNameContainer="" //Optional.[String].Default: "".
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "Deducibles", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un deducible"
                              }}
                            />
                          </Col>
                        </Row>

                        <Row >
                          <Col lg={4} md={12} sm={12} xs={12}>Riesgo Aplicado a la Cobertura de Robo</Col>
                          <Col lg={4} md={12} sm={12} xs={12}>
                            <Select
                              id={"selectRiesgos"} // Optional.[String].Default: "". Input ID.
                              name={"selectRiesgos"} // Optional.[String].Default: "". Input name.
                              value={riesgoSelected} // Optional.[String].Default: "".
                              optionList={arrayRiesgos} // Required.[Array of Object(s)].Default: [].
                              onChange={(riesgoSelected, e) => {
                                this.setState({ riesgoSelected, formEditado: true, habilitarBotonContinuar: false });
                              }} // Optional.[Func].Default: () => {}. Will return the value.
                              validate={validate}
                              validationCallback={res =>
                                this.setState({ validate: false })
                              }
                              classNameContainer="" //Optional.[String].Default: "".
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "Riesgo ", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un riesgo"
                              }}
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>

                  }
                  {this.state.esAdvance ?
                    <div>
                      {this.props.datosCarritoHogar.setPlanesHogarAdvance && this.props.datosCarritoHogar.setPlanesHogarAdvance.planesContenido != null && (

                        <Row>
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <Card className="flex-row">
                              <CardBody >
                                <h4 style={{ fontWeight: "bold" }}>Plan de contenidos</h4>
                                <p />

                                <div style={{ height: '800px' }}>
                                  <div style={{ position: 'absolute', top: 50, right: 0, bottom: 0, left: 0 }}>
                                    <Planes
                                      planSeleccionado={this.state.planContenidosSeleccionado}
                                      height={'60px'}
                                      planes={this.props.datosCarritoHogar.setPlanesHogarAdvance.planesContenido}
                                      onChangePlan={plan => {

                                        console.log(plan)
                                        this.setState({
                                          formEditado: true,
                                          planContenidosSeleccionado: plan.codigoProducto == this.state.planContenidosSeleccionado ? null : plan.codigoProducto,
                                        })

                                        setTimeout(() => {
                                          this.onValidateform()
                                        }, 300);
                                      }
                                      }
                                    />

                                  </div>
                                </div>




                              </CardBody>
                            </Card>
                          </Col>
                        </Row>



                      )}








                      {this.props.datosCarritoHogar.setPlanesHogarAdvance && this.props.datosCarritoHogar.setPlanesHogarAdvance.planesEstructura != null && (
                        <Row>
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <Card className="flex-row">
                              <CardBody >
                                <h4 style={{ fontWeight: "bold" }}>Plan de estructura</h4>
                                <p />

                                <div style={{ height: '1300px' }}>
                                  <div style={{ position: 'absolute', top: 50, right: 0, bottom: 0, left: 0 }}>
                                    <Planes
                                      planSeleccionado={this.state.planEstructuraSeleccionado}
                                      height={'120px'}
                                      planes={this.props.datosCarritoHogar.setPlanesHogarAdvance.planesEstructura}
                                      onChangePlan={plan => {
                                        this.setState({
                                          formEditado: true,
                                          planEstructuraSeleccionado: plan.codigoProducto == this.state.planEstructuraSeleccionado ? null : plan.codigoProducto,
                                        })

                                        setTimeout(() => {
                                          this.onValidateform()
                                        }, 300);
                                      }
                                      }
                                    />

                                  </div>
                                </div>




                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      )}




                    </div>
                    :
                    <div>
                      {/** --------------Seccion de Incendios ---------------------------------------------------------*/}
                      <Card className="flex-row">
                        <CardBody>
                          <h4 style={{ fontWeight: "bold" }}>{seccionIncendios.secNombre}</h4>
                          <p />
                          <Row>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label style={{ color: "#001871" }}>Valores Asegurados</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Tasa</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Prima</Label>
                            </Col>
                          </Row>
                          {arrayValoresSeccionIncendios.map((seccion, i) => {
                            let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                            let mensaje = "Debe ingresar un valor entre $0 y $" + valormaximo;
                            if (valormaximo === 999999999999) {
                              mensaje = "Debe espeficicar un valor, en caso de no desear la cobertura ingresar cero.";
                            }
                            return (
                              <Row key={i}>
                                <Col lg={3} md={3} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Textbox
                                    //tabIndex={i+1}
                                    type="text"
                                    id={seccion.cobCodigo}
                                    name={seccion.cobCodigo}
                                    disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                    classNameInput={"form-control"}
                                    placeholder="Ejemplo: (25000.52)"
                                    value={seccion.cobValorIngresado}
                                    validate={validate}
                                    onChange={(valor, e) => {
                                      arrayValoresSeccionIncendios[i] = { ...arrayValoresSeccionIncendios[i], cobValorIngresado: valor, cobValorCambioRecalcular: true }
                                      this.setState({ arrayValoresSeccionIncendios, formEditado: true, habilitarBotonContinuar: false })
                                    }}
                                    onBlur={e => { }}
                                    validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                    validationOption={{
                                      name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                      check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                      required: true,
                                      type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                      min: 0, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                      max: parseFloat(valormaximo),
                                      msgOnError: mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                    }}
                                  />
                                </Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Tasa</Col>
                                    <Col lg={12} md={12} sm={12} xs={12}><Label>{seccion.cobTasa} %</Label></Col>
                                  </Row>
                                </Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Prima</Col>
                                    <Col lg={12} md={12} sm={12} xs={12}><Label>$. {seccion.cobPrima}</Label></Col>
                                  </Row>
                                </Col>
                                <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                  <hr></hr>
                                </Col>
                              </Row>
                            );
                          })}

                          {arrayErroresIncendio !== undefined &&
                            <Alert color="warning">
                              <p>Por favor corregir la siguiente información para continuar:</p>
                              <ul >
                                {arrayErroresIncendio.map((error, i) => {
                                  return (
                                    <li >{error}</li>
                                  );

                                })}

                              </ul>
                            </Alert>
                          }

                        </CardBody>
                      </Card>



                      {/** --------------Seccion de Robo ---------------------------------------------- */}
                      <Card className="flex-row">
                        <CardBody>
                          <h4 style={{ fontWeight: "bold" }}>{seccionRobo.secNombre}</h4>
                          <p />
                          <Row>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label style={{ color: "#001871" }}>Valores Asegurados</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Tasa</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Prima</Label>
                            </Col>
                          </Row>
                          {arrayValoresSeccionRobo && arrayValoresSeccionRobo.map((seccion, i) => {
                            let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                            let mensaje = "Debe ingresar un valor entre $0 y $" + valormaximo;
                            if (valormaximo === 999999999999) {
                              mensaje = "Debe espeficicar un valor, en caso de no desear la cobertura ingresar cero.";
                            }
                            return (
                              <Row key={i}>
                                <Col lg={3} md={3} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Textbox
                                    //tabIndex={i+1}
                                    type="text"
                                    id={seccion.cobCodigo}
                                    name={seccion.cobCodigo}
                                    disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                    classNameInput={"form-control"}
                                    placeholder="Ejemplo: (25000.52)"
                                    value={seccion.cobValorIngresado}
                                    validate={validate}
                                    onChange={(valor, e) => {
                                      arrayValoresSeccionRobo[i] = { ...arrayValoresSeccionRobo[i], cobValorIngresado: valor }
                                      this.setState({ arrayValoresSeccionRobo, formEditado: true, habilitarBotonContinuar: false })
                                    }}
                                    onBlur={e => { }}
                                    validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                    validationOption={{
                                      name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                      check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                      required: true,
                                      type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                      min: 0, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                      max: parseFloat(valormaximo),
                                      msgOnError: mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                    }}
                                  />
                                </Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Tasa</Col>
                                    <Col lg={12} md={12} sm={12} xs={12}><Label>{seccion.cobTasa} %</Label></Col>
                                  </Row>
                                </Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Prima</Col>
                                    <Col lg={12} md={12} sm={12} xs={12}><Label>$. {seccion.cobPrima}</Label></Col>
                                  </Row>
                                </Col>
                                <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                  <hr></hr>
                                </Col>
                              </Row>
                            );
                          })}

                          {arrayErroresRobo !== undefined &&
                            <Alert color="warning">
                              <p>Por favor corregir la siguiente información para continuar:</p>
                              <ul >
                                {arrayErroresRobo.map((error, i) => {
                                  return (
                                    <li key={i}>{error}</li>
                                  );

                                })}

                              </ul>
                            </Alert>
                          }

                        </CardBody>
                      </Card>



                      {/** --------------Seccion de AMparo Basico de Daños Perdidas---------------------------------------------- */}

                      {arrayValoresAmparosBasicosDanios && arrayValoresAmparosBasicosDanios !== undefined && mostrarAmparosBasicosDanios &&

                        <Card className="flex-row">
                          <CardBody>
                            <h4 style={{ fontWeight: "bold" }}>{seccionAmparosBasicosDanios.secNombre ? seccionAmparosBasicosDanios.secNombre : ""}</h4>
                            <p />
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label>% Limite Asegurado</Label>
                              </Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label style={{ color: "#001871" }}>Valor Asegurado</Label>
                              </Col>
                            </Row>
                            {arrayValoresAmparosBasicosDanios.map((seccion, i) => {
                              let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                              let valorMinimo = seccion.cobValorIngresadoMinimo ? seccion.cobValorIngresadoMinimo : 0;
                              let mensaje = "Debe ingresar un valor entre $" + valorMinimo + " y $" + valormaximo;
                              if (valormaximo === 999999999999) {
                                mensaje = "Se otorga una gratuidad de esta cobertura hasta un valor de $" + valorMinimo;
                              }
                              return (
                                <Row key={i}>
                                  <Col lg={6} md={6} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>% Limite Asegurado</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>{seccion.cobTasa} %</Label></Col>
                                    </Row>
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Textbox
                                      //tabIndex={i+1}
                                      type="text"
                                      id={seccion.cobCodigo}
                                      name={seccion.cobCodigo}
                                      disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                      classNameInput={"form-control"}
                                      placeholder="Ejemplo: (25000.52)"
                                      value={seccion.cobValorIngresado}
                                      validate={validate}
                                      onChange={(valor, e) => {
                                        arrayValoresAmparosBasicosDanios[i] = { ...arrayValoresAmparosBasicosDanios[i], cobValorIngresado: valor, cobValorCambio: true }
                                        this.setState({ arrayValoresAmparosBasicosDanios, formEditado: true, habilitarBotonContinuar: false })
                                      }}
                                      onBlur={e => { }}
                                      validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                      validationOption={{
                                        name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true,
                                        type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                        min: parseFloat(valorMinimo), // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                        max: parseFloat(valormaximo),
                                        msgOnError: mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                      }}
                                    />
                                  </Col>
                                  <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                    <hr></hr>
                                  </Col>
                                </Row>
                              );
                            })}

                          </CardBody>
                        </Card>


                      }



                      {/** --------------Seccion de Amparo Gastos Adicionales Derivados de Siniestros ---------------------------------------------- */}

                      {arrayValoresAmparosBasicosDerivadoSiniestros && arrayValoresAmparosBasicosDerivadoSiniestros !== undefined && mostrarAmparosBasicosDerivadoSiniestros &&

                        <Card className="flex-row">
                          <CardBody>
                            <h4 style={{ fontWeight: "bold" }}>{seccionAmparosBasicosDerivadoSiniestros.secNombre ? seccionAmparosBasicosDerivadoSiniestros.secNombre : ""}</h4>
                            <p />
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label>% Limite Asegurado</Label>
                              </Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label style={{ color: "#001871" }}>Valor Asegurado</Label>
                              </Col>
                            </Row>
                            {arrayValoresAmparosBasicosDerivadoSiniestros.map((seccion, i) => {
                              let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                              let valorMinimo = seccion.cobValorIngresadoMinimo ? seccion.cobValorIngresadoMinimo : 0;
                              let mensaje = "Debe ingresar un valor entre $" + valorMinimo + " y $" + valormaximo;
                              if (valormaximo === 999999999999) {
                                mensaje = "Se otorga una gratuidad de esta cobertura hasta un valor de $" + valorMinimo;
                              }
                              return (
                                <Row key={i}>
                                  <Col lg={6} md={6} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>% Limite Asegurado</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>{seccion.cobTasa} %</Label></Col>
                                    </Row>
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Textbox
                                      //tabIndex={i+1}
                                      type="text"
                                      id={seccion.cobCodigo}
                                      name={seccion.cobCodigo}
                                      disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                      classNameInput={"form-control"}
                                      placeholder="Ejemplo: (25000.52)"
                                      value={seccion.cobValorIngresado}
                                      validate={validate}
                                      onChange={(valor, e) => {
                                        arrayValoresAmparosBasicosDerivadoSiniestros[i] = { ...arrayValoresAmparosBasicosDerivadoSiniestros[i], cobValorIngresado: valor, cobValorCambio: true }
                                        this.setState({ arrayValoresAmparosBasicosDerivadoSiniestros, formEditado: true, habilitarBotonContinuar: false })
                                      }}
                                      onBlur={e => { }}
                                      validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                      validationOption={{
                                        name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true,
                                        type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                        min: parseFloat(valorMinimo), // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                        max: parseFloat(valormaximo),
                                        msgOnError: mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                      }}
                                    />
                                  </Col>
                                  <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                    <hr></hr>
                                  </Col>
                                </Row>
                              );
                            })}

                          </CardBody>
                        </Card>


                      }




                      {/** --------------Seccion de Amparos Opcionales ---------------------------------------------- */}
                      <Card className="flex-row">
                        <CardBody>
                          <h4 style={{ fontWeight: "bold" }}>{seccionAmparosOpcionales.secNombre}</h4>
                          <p />
                          <Row>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label style={{ color: "#001871" }}>Valores Asegurados</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Tasa</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Prima</Label>
                            </Col>
                          </Row>
                          {arrayValoresAmparosOpcionales && arrayValoresAmparosOpcionales.map((seccion, i) => {
                            let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                            let mensaje = "Debe ingresar un valor entre $0 y $" + valormaximo;
                            if (valormaximo === 999999999999) {
                              mensaje = "Debe espeficicar un valor, en caso de no desear la cobertura ingresar cero.";
                            }
                            return (
                              <div>
                                <Row key={i}>
                                  <Col lg={3} md={3} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Textbox
                                      //tabIndex={i+1}
                                      type="text"
                                      id={seccion.cobCodigo}
                                      name={seccion.cobCodigo}
                                      disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                      classNameInput={"form-control"}
                                      placeholder="Ejemplo: (25000.52)"
                                      value={seccion.cobValorIngresado}
                                      validate={validate}
                                      onChange={(valor, e) => {
                                        arrayValoresAmparosOpcionales[i] = { ...arrayValoresAmparosOpcionales[i], cobValorIngresado: valor, cobValorCambio: true }
                                        this.setState({ arrayValoresAmparosOpcionales, formEditado: true, habilitarBotonContinuar: false })
                                        if (seccion.cobCodigo === "personalDomestico") {
                                          if (parseFloat(valor) > 0) {
                                            this.setState({ verNumeroPersonasAP: true })
                                          }
                                          else {
                                            this.setState({ verNumeroPersonasAP: false })
                                          }

                                        }
                                      }}
                                      onBlur={e => { }}
                                      validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                      validationOption={{
                                        name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true,
                                        type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                        min: 0, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                        max: parseFloat(valormaximo),
                                        msgOnError: mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                      }}
                                    />
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Tasa</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>{seccion.cobTasa} %</Label></Col>
                                    </Row>
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Prima</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>$. {seccion.cobPrima}</Label></Col>
                                    </Row>
                                  </Col>
                                  <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                    <hr></hr>
                                  </Col>
                                </Row>
                                {seccion.cobCodigo && seccion.cobCodigo === "personalDomestico" && verNumeroPersonasAP &&
                                  <Row key={i + 999}>
                                    <Col lg={3} md={3} sm={12} xs={12}>{seccion.labelIngresoPersonas ? seccion.labelIngresoPersonas : 'Ingresar Nro de Personas(Menores a 65 años)'}</Col>
                                    <Col lg={3} md={3} sm={12} xs={12}>
                                      <Textbox
                                        //tabIndex={i+1}                                                  
                                        type="text"
                                        id={"numeroPersonasAP"}
                                        name={"numeroPersonasAP"}
                                        disabled={false} // Optional.[Bool].Default: false.
                                        classNameInput={"form-control"}
                                        placeholder="Ejemplo : 4"
                                        value={seccion.cobNumeroPersonas}
                                        validate={validate}
                                        onChange={(valor, e) => {
                                          arrayValoresAmparosOpcionales[i] = { ...arrayValoresAmparosOpcionales[i], cobNumeroPersonas: valor }
                                          this.setState({ arrayValoresAmparosOpcionales, formEditado: true, NumeroPersonasvalidador: valor })
                                        }}
                                        onBlur={e => { }}
                                        validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                        validationOption={{
                                          name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                          required: true,
                                          type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                          min: 1, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                          max: parseInt(seccion.cobValorMaximoNumeroPersonas),
                                          msgOnError: 'Debe ingresar el número de personas entre 1 y ' + seccion.cobValorMaximoNumeroPersonas // Optional.[Bool].Default: true. To determin if it is a required field.
                                        }}
                                      />
                                    </Col>
                                    <Col lg={3} md={3} sm={12} xs={12}></Col><Col lg={3} md={3} sm={12} xs={12}></Col>
                                    <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                      <hr></hr>
                                    </Col>
                                  </Row>
                                }
                              </div>
                            );
                          })}

                          {arrayErroresAmparosOpcionales !== undefined &&
                            <Alert color="warning">
                              <p>Por favor corregir la siguiente información para continuar:</p>
                              <ul >
                                {arrayErroresAmparosOpcionales.map((error, i) => {
                                  return (
                                    <li key={i}>{error}</li>
                                  );

                                })}

                              </ul>
                            </Alert>
                          }

                        </CardBody>
                      </Card>
                    </div>
                  }







                </div>
              }

            </Col>

            <Col lg={4} md={12} className="detalle-impuestos-box" >

              <ValoresCotizacionHogar formEditado={formEditado} paso={"valores-cotizacion"} metodo={this.onValidateform} cargarTotalesRecuperado={cargarTotalesRecuperado} esHogarAdvance={this.state.esAdvance} habilitarBotonContinuar={(this.state.esAdvance == false) ? habilitarBotonContinuar : (this.state.planContenidosSeleccionado != null || this.state.planEstructuraSeleccionado != null) ? false : true} />
            </Col>
          </Row>
        </Page>
      </LoadingScreen>
    );
  }
};

const mapStateToProps = state => ({
  seccionesCoberturasHogar: state.datosCarritoHogar.setSeccionesCoberturasHogar,
  carrito: state.datosCarritoHogar.setCarritoHogar,
  datosCarritoHogar: state.datosCarritoHogar,
  catalogosHogar: state.catalogosHogar,
  dataFacturacion: state.dataFacturacion.datosFacturacion
});

const mapDispatchToProps = dispatch => {
  return {
    caluloPrima: (param) => dispatch(FetchCalculoPrimaHogar(param)),
    listarCarritoHogar: (param) => dispatch(FetchListarCarritoHogar(param)),
    setProductoActual: (param) => dispatch(setProductoActualCotizadoHogar(param)),
    guardarGenerarPdfCotizacion: (param) => dispatch(FetchGenerarEnviarPdfHogar(param)),
    actualizarTotalesCabecera: (param) => dispatch(FetchTotalesCabeceraCotizadores(param)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    cargarCoberturasHogarAdvance: () => dispatch(FetchDataCoberturasHogarAdvance()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionValoresPaso4)
);
